const requireNotEmpty = require('../common/validate-textfield.js');
const phone_utils = require('../common/phone-utils');
const validatePhoneNumber = require('../common/validate-phonenumber');
const paymentGateway = require('../common/payment-gateway');

const debounce = require('lodash.debounce');
const moment = require('moment');

module.exports = {
	init: () => {
		//window.jQuery('#btnEngravableProductDiscount').on('click', openDiscount);

		window.jQuery('#membershippayform').on('submit', handleFormSubmit);

		window.jQuery('#frmDiscounts').on('submit', addDiscount);

		window.jQuery('#gift').on('keyup change blur', updateSubtotal);

		window.jQuery('#lifewallText').on('keyup change', lifewallKeystrokesDebounced).keyup();

		window.jQuery('#subtotalLabel').on('click', '.applyDiscount', openDiscount);

		window.jQuery('input[name="payHow"]').on('change', updateSubtotal);

		window.jQuery('.toggleJointGift').on('click', toggleIsJointGift);

		window.jQuery('#billingSameAddress').on('change', toggleBillingAddressChange).change();
		window.jQuery('#jointSameAddress').on('change', toggleSecondAddressChange).change();

		window.jQuery('.copyToOtherFields').on('keyup change blur', copyToOtherFieldsDebounced);

		window.jQuery('#subtotalLabel').on('click', '.removeDiscountCode', removeDiscountCode);
		if (document.querySelector('#phoneNumber')){
			phone_utils.setup_intl_tel_input(
				'#phoneNumber',
				'#phoneNumberValue',
				'#phoneDialCodeValue',
				'#phoneCountryCodeValue'
			);
		}
		if (document.querySelector('#firstMemberPhoneNumber')){
			phone_utils.setup_intl_tel_input(
				'#firstMemberPhoneNumber',
				'#firstMemberPhoneNumberValue',
				'#firstMemberPhoneDialCodeValue',
				'#firstMemberPhoneCountryCodeValue'
			);
		}
		if (document.querySelector('#secondMemberPhoneNumber')){
			phone_utils.setup_intl_tel_input(
				'#secondMemberPhoneNumber',
				'#secondMemberPhoneNumberValue',
				'#secondMemberPhoneDialCodeValue',
				'#secondMemberPhoneCountryCodeValue'
			);
		}

		window
			.jQuery('#phoneNumber,#firstMemberPhoneNumber,#secondMemberPhoneNumber')
			.closest('.intl-tel-input')
			.css('width', '100%');

		updateSubtotal();

		initGateway();
		window.jQuery('#firstName,#lastName,#firstMemberFirstName,#firstMemberLastName').on('change', initGateway);

		return true;
	}
};

const initGateway = () => {
	window.jQuery('#gateway-container').empty();

	let fullNameLabel =
		window.jQuery('#firstName').length > 0
			? window.jQuery('#firstName').val() + ' ' + window.jQuery('#lastName').val()
			: window.jQuery('#firstMemberFirstName').val() + ' ' + window.jQuery('#firstMemberLastName').val();

	paymentGateway.init({
		braintreeConfig: {
			containerId: '#gateway-container',
			submitBtnSelector: '#openPay',
			venmo: {
				allowNewBrowserTab: true //set this to false in places where refreshing the page would break it (like a SPA)
			},
			paypal: {
				flow: 'vault'
			},
			applePay: {
				displayName: fullNameLabel,
				paymentRequest: {
					total: {
						label: 'Membership Fees',
						amount: window.jQuery('#subtotal').val() //yes, this one expects the value as a string, but with no dollar sign character prefix
					}
				}
			},
			googlePay: {
				transactionInfo: {
					totalPrice: window.jQuery('#subtotal').val() //yes, this one expects the value as a string, but with no dollar sign character prefix
				}
			}
		},
		spreedlyConfig: {
			company_name: window.iq.customerName,
			sidebar_top_description: 'Membership'
		},
		onSubmitting: () => {
			//the button is automatically disabled, this callback allows us to make other UI changes
			//this is only called after tokenization succeeds
			window.jQuery('#openPay i').removeClass('fa-usd').addClass('fa-circle-o-notch fa-spin');
			window.jQuery('#openPay').prop('disabled', true).addClass('disabled');
		}
	});
};

const addDiscount = (e) => {
	e.preventDefault();
	window.jQuery
		.ajax({
			url: `/index.cfm/membership:home/addDiscount`,
			cache: false,
			data: {
				pc: window.jQuery('#discountcode').val()
			}
		})
		.then(() => {
			window.jQuery('#errorBox').addClass('hide');
			updateSubtotal();
			window.jQuery('#winDiscounts').modal('hide');
		})
		.fail((jqXHR) => {
			window
				.jQuery('#errorBox')
				.removeClass('hide')
				.find('ul')
				.html(JSON.parse(jqXHR.responseText).ERRORS.map((i) => `<li>${i}</li>`));
			window.jQuery('#winDiscounts').modal('hide');
			jump('errorBox');
		});
	return false;
};

const cleanupGift = debounce(() => {
	let gift = 0;
	if (window.jQuery('#gift').length > 0) {
		gift = window
			.jQuery('#gift')
			.val()
			.toString()
			.replace(/[^\d\.]?/gi, '');
	}

	if (/\.{1}[0-9]{1,}/.test(gift)) {
		gift = parseFloat(gift).toFixed(2);
	}

	if (isNaN(gift)) {
		window.jQuery('#gift').val('');
		return;
	}

	window.jQuery('#gift').val(gift);
}, 1500);

const copyToOtherFields = (e) => {
	let $target = window.jQuery(e.target);
	let targetName = $target.attr('name');
	if (window.jQuery('#jointSameAddress').is(':checked')) {
		let secondMemberFieldId = targetName.replace(/firstMember/gi, 'secondMember');
		window.jQuery('#' + secondMemberFieldId).val(window.jQuery(e.target).val());
	}
	if (window.jQuery('#billingSameAddress').is(':checked')) {
		let billingFieldId = targetName.replace(/firstMember/gi, 'billing');
		window.jQuery('#' + billingFieldId).val(window.jQuery(e.target).val());
	}
};

const copyToOtherFieldsDebounced = debounce(copyToOtherFields, 100);

const lifewallKeystrokes = (e) => {
	let $lifewall = window.jQuery(e.target);
	let limit = window.iq.lifewallCharacterLimit;
	let len = $lifewall.val().length;
	$lifewall
		.closest('div')
		.find('.lifewallCharsRemaining')
		.html(limit - len);
	$lifewall.val($lifewall.val().substr(0, limit));
};

const lifewallKeystrokesDebounced = debounce(lifewallKeystrokes, 100);

const openDiscount = (e) => {
	e.preventDefault();
	window.jQuery('#discountcode').val('');
	window.jQuery('#winDiscounts').modal('show');
};

const handleFormSubmit = (e) => {
	// Because of auto complete we want to look one last time
	// to see if we should copy these fields down
	if (window.jQuery('#jointSameAddress').is(':checked')) {
		copyFirstToSecond();
	}

	if (window.jQuery('#billingSameAddress').is(':checked')) {
		copyFirstToBilling();
	}

	let error = validateForm();

	if (error) {
		e.preventDefault();
		return false;
	}

	if (window.jQuery('#paymentToken').val() === '') {
		let fullNameLabel =
			window.jQuery('#firstName').length > 0
				? window.jQuery('#firstName').val() + ' ' + window.jQuery('#lastName').val()
				: window.jQuery('#firstMemberFirstName').val() + ' ' + window.jQuery('#firstMemberLastName').val();

		paymentGateway.update({
			amountDisplay: '$' + window.jQuery('#subtotal').val(),
			fullName: fullNameLabel,
			email: window.jQuery('#emailAddress').val(),
			street1: window.jQuery('#billingAddress1').val(),
			street2: window.jQuery('#billingAddress2').val(),
			city: window.jQuery('#billingCity').val(),
			state: window.jQuery('#billingState').val(),
			postalCode: window.jQuery('#billingPostalCode').val(),
			nation: window.jQuery('#billingNation').val()
		});
		paymentGateway.tokenize();

		e.preventDefault();
		return false;
	}

	return true;
};

const copyFirstToBilling = () => {
	window.jQuery('#billingAddressType').val(window.jQuery('#firstMemberAddressType').val());
	window.jQuery('#billingAddress1').val(window.jQuery('#firstMemberAddress1').val());
	window.jQuery('#billingAddress2').val(window.jQuery('#firstMemberAddress2').val());
	window.jQuery('#billingCity').val(window.jQuery('#firstMemberCity').val());
	window.jQuery('#billingState').val(window.jQuery('#firstMemberState').val());
	window.jQuery('#billingPostalCode').val(window.jQuery('#firstMemberPostalCode').val());
	window.jQuery('#billingNation').val(window.jQuery('#firstMemberNation').val());
};

const toggleBillingAddressChange = () => {
	let $billingAddressFields = window.jQuery('#billingAddressFields');
	if (!window.jQuery('#billingSameAddress').is(':checked')) {
		window.jQuery('#billingAddressType').val('');
		window.jQuery('#billingAddress1').val('');
		window.jQuery('#billingAddress2').val('');
		window.jQuery('#billingCity').val('');
		window.jQuery('#billingState').val('');
		window.jQuery('#billingPostalCode').val('');
		window.jQuery('#billingNation').val('');
		$billingAddressFields.removeClass('hide');
	} else {
		$billingAddressFields.addClass('hide');
		copyFirstToBilling();
	}
};

const copyFirstToSecond = () => {
	window.jQuery('#secondMemberAddressType').val(window.jQuery('#firstMemberAddressType').val());
	window.jQuery('#secondMemberAddress1').val(window.jQuery('#firstMemberAddress1').val());
	window.jQuery('#secondMemberAddress2').val(window.jQuery('#firstMemberAddress2').val());
	window.jQuery('#secondMemberCity').val(window.jQuery('#firstMemberCity').val());
	window.jQuery('#secondMemberState').val(window.jQuery('#firstMemberState').val());
	window.jQuery('#secondMemberPostalCode').val(window.jQuery('#firstMemberPostalCode').val());
	window.jQuery('#secondMemberNation').val(window.jQuery('#firstMemberNation').val());
};

const toggleSecondAddressChange = () => {
	let $secondMemberAddressFields = window.jQuery('#secondAddressFields');
	if (!window.jQuery('#jointSameAddress').is(':checked')) {
		window.jQuery('#secondMemberAddressType').val('');
		window.jQuery('#secondMemberAddress1').val('');
		window.jQuery('#secondMemberAddress2').val('');
		window.jQuery('#secondMemberCity').val('');
		window.jQuery('#secondMemberState').val('');
		window.jQuery('#secondMemberPostalCode').val('');
		window.jQuery('#secondMemberNation').val('');
		$secondMemberAddressFields.removeClass('hide');
	} else {
		$secondMemberAddressFields.addClass('hide');
		copyFirstToSecond();
	}
};

const removeDiscountCode = (e) => {
	e.preventDefault();
	//let $href = window.jQuery(e.target).prop('href');
	//console.log($href);
	window.jQuery
		.ajax({
			url: `/index.cfm/membership:home/removediscount`,
			cache: false,
			data: {
				code: window.jQuery(e.target).data('code')
			}
		})
		.then(() => {
			updateSubtotal();
		});
	return false;
};

const updateSubtotal = () => {
	cleanupGift();

	window
		.jQuery('#subtotalLabel')
		.html(
			'<p style="text-align:center"><img src="/assets/img/loading.gif" style="max-width: 220px" /><br/>Recalculating</p>'
		);

	window.jQuery
		.ajax({
			url: '/index.cfm/membership:home/updateSubtotal',
			cache: false
		})
		.then((result) => {
			// console.log(result);
			let today = 0;
			let membershipTypeAmount = parseFloat(result.membershipTypeAmount) / 100;
			let makePayments = parseInt(window.jQuery('input[name="payHow"]:checked').val()) || 0 === 1;
			let numberOfPayments = window.jQuery('#membershipTypeRate').data('numberofpayments') || 0;
			let gift = parseFloat(window.jQuery('#gift').val());

			if (isNaN(membershipTypeAmount)) {
				membershipTypeAmount = 0;
			}

			let upgradeCredit = result.upgradeCreditCents / 100;
			let membershipDiscount = result.membershipDiscount.amount / 100;
			let productsDiscount = result.engravableProductDiscount.amount / 100;
			let membershipTypeAmountAfterDiscount = membershipTypeAmount - membershipDiscount - upgradeCredit;
			let productsAmountAfterDiscount = result.engravableProductTotal / 100 - productsDiscount;

			let paymentsAmount = membershipTypeAmountAfterDiscount / numberOfPayments;

			let selectedMembershipPayment = makePayments ? paymentsAmount : membershipTypeAmountAfterDiscount;

			// we also want numbers if we've got a discount and fun stuff like making payments

			let originalMembershipTypeAmount = membershipTypeAmount;
			let originalProductsAmount = result.engravableProductTotal / 100;

			let originalPaymentsAmount = membershipTypeAmount / numberOfPayments;

			let originalSelectedMembershipPayment = makePayments ? originalPaymentsAmount : originalMembershipTypeAmount;

			// end the extra numbers

			today = selectedMembershipPayment + productsAmountAfterDiscount;

			if (!isNaN(gift)) {
				today += gift;
			}

			window.jQuery('#oneTimePaymentAmount').html(`$${membershipTypeAmountAfterDiscount.toFixed(2)}`);
			window.jQuery('#monthlyPaymentAmount').html(`$${paymentsAmount.toFixed(2)}`);
			window.jQuery('#subtotal').val(today.toFixed(2));

			let displaySubtotal = `<table class="table">
			<tr>
				<td>
					<strong>Today's membership payment</strong>
					${upgradeCredit > 0 ? `<br/>Upgrade credit: $${upgradeCredit.toFixed(2)}` : ''}
					${
						membershipDiscount >= 0 && result.membershipDiscount.code && result.membershipDiscount.code !== ''
							? `<br/>Using promo code: ${result.membershipDiscount.code} - $${membershipDiscount.toFixed(2)} off<br/>
						<a href="javascript:void(0)" data-code="${result.membershipDiscount.code}" class="removeDiscountCode">Remove code</a>
						| <a href="#" class="applyDiscount">Change code</a></p>`
							: ''
					}
				</td>
				<td style="text-align: right">${
					upgradeCredit + membershipDiscount > 0 ? `<del>$${originalSelectedMembershipPayment.toFixed(2)}</del> ` : ``
				}$${selectedMembershipPayment.toFixed(2)}</td>
			</tr>
			${
				result.engravableProductTotal === 0
					? ''
					: `
				<tr>
					<td>
						<strong>Products</strong>
						<br/>${result.engravableProduct.name}
						${
							result.engravableProduct.engraving.length > 0
								? `<br/>Engraving:<br/><span class="engravingSample"
						>${result.engravableProduct.engraving.replace(/\n/gi, '<br/>')}</span>`
								: ''
						}
						<br/>School stamp: ${result.engravableProduct.schoolStamp ? 'Yes' : 'No'}
						${
							productsDiscount > 0
								? `<br/>Using discount code: ${result.engravableProductDiscount.code} - $${productsDiscount.toFixed(
										2
								  )} off<br/>
							<a href="javascript:void(0)" data-code="${
								result.engravableProductDiscount.code
							}" class="removeDiscountCode">Remove code</a>
							| <a href="#" class="applyDiscount">Change code</a>`
								: ''
						}
					</td>
					<td style="text-align: right">${
						productsDiscount > 0 ? `<del>$${originalProductsAmount.toFixed(2)}</del> ` : ''
					}$${productsAmountAfterDiscount.toFixed(2)}</td>
				</tr>
			`
			}
			${
				!isNaN(gift) && gift > 0
					? `
				<tr>
					<td><strong>Your gift</strong></td>
					<td style="text-align: right">$${gift.toFixed(2)}</td>
				</tr>
				`
					: ''
			}
			<tr>
				<td><h4 style="margin-bottom:10px; margin-top:10px">Total Today</h4></td>
				<td style="text-align: right">
					<h4 style="margin-bottom:10px; margin-top:10px">$${today.toFixed(2)}</h4>
				</td>
			</tr>
			${
				makePayments
					? `
				<tr>
					<td>
						<h4 style="margin-bottom:10px; margin-top:10px">${numberOfPayments - 1} future installments of
						<br /><small>2nd payment on ${moment(window.iq.secondPaymentDate).format('MMMM Do, YYYY')}</small>
						</h4>
					</td>
					<td style="text-align: right">
						<h4 style="margin-bottom:10px; margin-top:10px">${paymentsAmount.toFixed(2)}</h4>
					</td>
				</tr>
			`
					: ''
			}
		</table>`;

			let showDiscountCard = false;
			if ((result.membershipDiscount.code || '' !== '') && (result.membershipDiscount.amount || 0 > 0)) {
				showDiscountCard = true;
				window
					.jQuery('#membershipDiscountAmount')
					.html(`$${(parseFloat(result.membershipDiscount.amount) / 100).toFixed(2)}`);
				window.jQuery('#dispMembershipDiscount').removeClass('hide');
			} else {
				window.jQuery('#dispMembershipDiscount').addClass('hide');
			}

			if (
				(result.engravableProductDiscount.code || '' !== '') &&
				(result.engravableProductDiscount.amount || 0 > 0) &&
				window.iq.engravableDiscountsCount > 0
			) {
				showDiscountCard = true;
				window.jQuery('#engravableProductDiscountAmount').html(
					`
					$${(result.engravableProductDiscount.amount / 100).toFixed(2)}
					`
				);
				window.jQuery('#dispEngravableProductDiscount').removeClass('hide');
			} else {
				window.jQuery('#dispEngravableProductDiscount').addClass('hide');
			}

			if (showDiscountCard) {
				window.jQuery('#dispPromoCode').removeClass('hide');
			} else {
				window.jQuery('#dispPromoCode').addClass('hide');
			}

			if ((result.membershipDiscount.amount || 0) === 0 || (result.engravableProductDiscount.amount || 0) === 0) {
				displaySubtotal += `<p><a href="javascript:void(0)" class="applyDiscount" > Apply Promo / Discount Code </a></p> `;
			}

			window.jQuery('#subtotalLabel').html(displaySubtotal);
			initGateway();
		});
};

const validateForm = () => {
	let $gift = window.jQuery('#gift');
	let giftMin = parseFloat($gift.prop('min'));
	let giftVal = $gift.val();
	if (giftVal !== '' && giftVal < giftMin) {
		$gift.closest('.errorContainer').addClass('has-error');
		window.location.href = '#giftBox';
		return true;
	} else {
		$gift.closest('.errorContainer').removeClass('has-error');
	}

	let error = false;
	error = requireNotEmpty('.isRequired', '.errorContainer', 'has-error has-feedback') || error;
	if (document.querySelector('#phoneNumber')){
		error = validatePhoneNumber('#phoneNumber', '.errorContainer', 'has-error has-feedback') || error;
	}
	if (document.querySelector('#firstMemberPhoneNumber')){
		error = validatePhoneNumber('#firstMemberPhoneNumber', '.errorContainer', 'has-error has-feedback') || error;
	}

	window.jQuery('.has-feedback').find('.form-control-feedback').removeClass('hide');
	window.jQuery('.errorContainer').not('.has-feedback').find('.form-control-feedback').addClass('hide');

	if (error) {
		window.jQuery('#alertMissingInformation').removeClass('hide');
		window.location.href = '#scrollToAlert';
	} else {
		window.jQuery('#alertMissingInformation').addClass('hide');
	}

	return error;
};

const jump = (h) => {
	var top = document.getElementById(h).offsetTop;
	window.scrollTo(0, top);
};

const toggleIsJointGift = (e) => {
	let isYes = window.jQuery(e.target).is('.yes');

	if (isYes) {
		window.jQuery('.no').addClass('btn-default').removeClass('active btn-primary').find('i').addClass('hide');
		window.jQuery('.yes').addClass('active btn-primary').removeClass('btn-default').find('i').removeClass('hide');
		window.jQuery('#jointNameOnGiftDiv').removeClass('hide');
		window.jQuery('#jointNameOnGift').addClass('isRequired').closest('div').addClass('errorContainer');
	} else {
		window.jQuery('.no').addClass('active btn-primary').removeClass('btn-default').find('i').removeClass('hide');
		window.jQuery('.yes').addClass('btn-default').removeClass('active btn-primary').find('i').addClass('hide');
		window.jQuery('#jointNameOnGiftDiv').addClass('hide');
		window.jQuery('#jointNameOnGift').removeClass('isRequired').closest('div').removeClass('errorContainer');
	}
};
